const $ = jQuery.noConflict();

'use strict';
const Accordion = {

	init: function() {
		this.accordion();
	},
	accordion: function() {
		// Check if all accordions should stay open
		const $accordion = $('.js-acc');
		const allOpen = $accordion.find('.js-acc-item--open').length > 0;

		// If all accordions should be open, show all content and return early
		if (allOpen) {
			$accordion.find('.js-acc-content').show();
			$accordion.find('.js-acc-item').addClass('active');
			$accordion.find('.js-title').addClass('active');
			return; // Exit early, don't bind click events
		}

		// Normal accordion behavior
		$('.js-title').on('click', function(j) {
			const dropDown = $(this).closest('.js-acc-item').find('.js-acc-content');
			$('.js-title').closest('.js-acc').find('.js-acc-content').not(dropDown).slideUp();
			if ($(this).hasClass('active') && $(this).parent().hasClass('active')) {
				$('.js-title').removeClass('active');
				$('.js-title').closest('.js-acc').find('.js-acc-item.active').removeClass('active');
			} else {
				$('.js-title').closest('.js-acc').find('.js-title.active').removeClass('active');
				$('.js-title').closest('.js-acc').find('.js-acc-item.active').removeClass('active');
				$(this).parent().addClass('active');
				$(this).addClass('active');
			}
			dropDown.stop(false, true).slideToggle();
			j.preventDefault();
		});
	}
};
export default Accordion;